import { render, staticRenderFns } from "./EmailAddressInput.vue?vue&type=template&id=5a1ca40b&"
import script from "./EmailAddressInput.vue?vue&type=script&lang=ts&"
export * from "./EmailAddressInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports